export type BetOption = "BIG" | "SMALL" | "ODD" | "EVEN";

export const BET_OPTIONS: { option: BetOption; labelKey: string }[] = [
  { option: "BIG", labelKey: "game_bet_big" },
  { option: "SMALL", labelKey: "game_bet_small" },
  { option: "ODD", labelKey: "game_bet_odd" },
  { option: "EVEN", labelKey: "game_bet_even" },
];

export const BIG_THRESHOLD = 5;

export const isBig = (value: number) => value >= BIG_THRESHOLD;

export const isOdd = (value: number) => value % 2 === 1;

export const matchesOption = (value: number, option: BetOption): boolean => {
  switch (option) {
    case "BIG":
      return isBig(value);
    case "SMALL":
      return !isBig(value);
    case "ODD":
      return isOdd(value);
    case "EVEN":
      return !isOdd(value);
  }
};

export const summarise = (value: number) =>
  `${isBig(value) ? "大" : "小"} · ${isOdd(value) ? "单" : "双"}`;
